// extracted by mini-css-extract-plugin
export default {"wrapper":"gq-z","response":"hq-z","error":"iq-z","disabled":"jq-z","buttons":"kq-z","feedbackQuestionSection":"lq-z","yesNoWrapper":"mq-z"};